import React from 'react';
import {Text} from 'react-native';

import Card from '/component/base/Card';
import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import Carousel from '../Carousel';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={1}>Carousel</Heading>
      <Spacing size={16} />
      <Text>
        This <Code>{'Carousel'}</Code> component is used to render a carousel to
        cycle through elements.
      </Text>
      <Spacer size={10} />
      <Text>
        The carousel has a maximum of three children and can be navigated only
        by swiping. The dots will be colored based on the competency level.
      </Text>
    </Spacing>
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Carousel>
          <Card>
            <Text>Card 1</Text>
          </Card>
          <Card>
            <Text>Card 2</Text>
          </Card>
          <Card>
            <Text>Card 3</Text>
          </Card>
        </Carousel>
      </FlexView>
    </FlexView>
  </>
);
